import {ProductionCostEntryOrigin} from '@/Pages/Home/store/types';

export const CalculationOriginFilterOptions = [
  {
    id: 'automated',
    value: ProductionCostEntryOrigin.Automated,
    name: 'calculationOrigin',
    label: 'Automated'
  },
  {
    id: 'manual',
    value: ProductionCostEntryOrigin.Manual,
    name: 'calculationOrigin',
    label: 'Manual'
  }
];
